import styled from '../../../../theme'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'

const HintWrapper = styled.div<IWithSize & { width?: number }>`
  width: ${({ size, width }) =>
    size ? (width ? width : 360 * size) : width ? width : 360}px;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  @media (max-width: 400px) {
    width: 90vw;
  }
`

export default HintWrapper
